'use strict';

require('url-search-params-polyfill');

var JSConstants = require('_core_ext/pages/storelocator/constants'),
    JSCommonConstants = require('_core_ext/constants'),
    handlebarsHelper = require('_core_ext/handlebarsHelper'),
    layout = require('_core_ext/layout'),
    _ = require('lodash');

var KILOMETERS_CONVERSATION_LEVEL = Constants.KILOMETERS_CONVERSATION_LEVEL;
var $googleMapSection = $(JSConstants.CLASS_MAIN_WRAPPER);
var urlParams = new URLSearchParams(window.location.search);
var searchTerm = urlParams.get('searchTerm');
var storeIdUrlParam = urlParams.get('StoreID');

var selectors = {
    map: JSConstants.CLASS_GOOLEMAPS_MAP,
    nearestStore: JSConstants.CLASS_NEAREST_STORE,
    selectStoreBtn: JSConstants.CLASS_SELECT_STORE,
    addressField: JSConstants.CLASS_ADDRESS_STORE,
    storeRadius: JSConstants.CLASS_STORE_RADIUS,
    nearestStoresBlock: JSConstants.CLASS_NEAREST_STORES_BLOCK,
    selectedStoreBlock: JSConstants.CLASS_SELECTED_STORE_BLOCK,
    showNearestStoresLink: JSConstants.CLASS_SHOW_NEAREST_STORE_LINK,
    nearestStoreRadioBtn: JSConstants.CLASS_NEAREST_STORE_RADIO_BTN,
    tabs: JSConstants.CLASS_GOOFLEMAPS_TABS,
    fakeLink: JSConstants.CLASS_FAKE_LINK,
    msgBoxContainer: JSConstants.CLASS_MSG_BOX_CONTAINER,
    proceedToPaymentBtn: JSConstants.CLASS_PROCEED_TO_PAYMENT_BTN,
    azViewContainer: JSConstants.CLASS_AZ_VIEW_CONTAINER,
    storeResultsInfo: JSConstants.CLASS_STORE_RESULTS_INFO,
    liveAnnounce: JSConstants.CLASS_STORE_LIVE_ANNOUNCE,
    findBtn: JSConstants.CLASS_FIND_BTN,
    searchByCurrentLocation: JSConstants.CLASS_SEARCH_BY_CURRENT_LOCATION,
    browseAZBtn: JSConstants.CLASS_BROWSE_AZ_BTN,
    azView: JSConstants.CLASS_AZ_VIEW,
    mapView: JSConstants.CLASS_MAP_VIEW,
    mobileTabs: JSConstants.CLASS_MOBILE_TABS,
    mobileTab: JSConstants.CLASS_MOBILE_TAB,
    mobileTabLocations: JSConstants.CLASS_MOBILE_TAB_LOCATIONS,
    mobileTabMap: JSConstants.CLASS_MOBILE_TAB_MAP,
    mobileSelectedStoreBlock: JSConstants.CLASS_MOBILE_SELECTED_STORE_BLOCK,
    refinementError: JSConstants.CLASS_REFINEMENT_ERROR,
    linkToDetailPage: JSConstants.CLASS_LINK_DETAIL_PAGE,
};

var $cache = generateCache(selectors),
    isInited = false,
    map,
    marker,
    geocoder,
    infoWindow,
    autocomplete,
    stores = [],
    storeMarkers = [],
    userIcon,
    isHideStoreMarker = false,
    showDistance = false,
    activeMobileTab = JSConstants.MOBILE_TAB_LOCATIONS,
    highlightedMarker = null,
    pendingMobileMapStores = null;

function getLastSearchState() {
    if (searchTerm) {
        $cache.addressField.val(searchTerm);
        $(selectors.findBtn).click();
        $googleMapSection.one('areaSelectedEvent', function () {
            selectStore(storeIdUrlParam);
            storeIdUrlParam = null;
        });
    }
}

function generateCache(selectors) {
    var $cache = {};
    for (var key in selectors) {
        $cache[key] = $(selectors[key]);
    }
    return $cache;
}

function updateMapAriaLabel(searchLocation) {
    if (!$cache.map || !$cache.map.length) {
        return;
    }

    var label = searchLocation
        ? Resources.STORELOCATOR_MAP_ARIA.replace('{0}', searchLocation)
        : Resources.STORELOCATOR_MAP_ARIA_DEFAULT;

    $cache.map.attr('aria-label', label);
}

function announceMapCentered(storeName) {
    if (!storeName || !$cache.liveAnnounce || !$cache.liveAnnounce.length) {
        return;
    }

    var message = Resources.STORELOCATOR_MAP_CENTERED.replace('{0}', storeName);

    $cache.liveAnnounce.text('');
    setTimeout(function () {
        $cache.liveAnnounce.text(message);
    }, 50);
}

window.initStorelocatorMap = function() {
    userIcon = {
        url: Urls.mapUserIcon
    };

    map = new google.maps.Map($cache.map[0], {
        zoom: SitePreferences.DEFAULT_MAP_ZOOM,
        center: SitePreferences.DEFAULT_MAP_CENTER,
        disableDefaultUI: true,
        zoomControl: true,
        streetViewControl: true
    });

    marker = new google.maps.Marker({
        position: SitePreferences.DEFAULT_MAP_CENTER,
        map: map,
        icon: userIcon
    });

    geocoder = new google.maps.Geocoder();

    infoWindow = new google.maps.InfoWindow();

    autocomplete = new google.maps.places.Autocomplete($cache.addressField[0]);

    autocomplete.setComponentRestrictions({
        'country': [getRegionByLocale(SitePreferences.LOCALE)]
    });

    loadStores();
    initEvents();
    showAZView();
};

function isMobileStoreLocatorView() {
    return layout.isMobile();
}

function setMobileTabsVisibility(isVisible) {
    if (!$cache.mobileTabs.length) {
        return;
    }

    $cache.mobileTabs.prop('hidden', !isVisible);
    $cache.mapView
        .toggleClass(JSConstants.CLASS_MOBILE_RESULTS_ACTIVE, isVisible);
}

function setMobileLocationsTabDisabled(isDisabled) {
    if (!isMobileStoreLocatorView() || !$cache.mobileTabLocations.length) {
        return;
    }

    $cache.mobileTabLocations
        .toggleClass(JSConstants.CLASS_MOBILE_TAB_DISABLED, isDisabled)
        .attr('aria-disabled', isDisabled)
        .attr('tabindex', isDisabled ? '-1' : '0');

    if (isDisabled && activeMobileTab === JSConstants.MOBILE_TAB_LOCATIONS) {
        setMobileActiveTab(JSConstants.MOBILE_TAB_MAP);
    }
}

function setMobileActiveTab(tabName) {
    if (!isMobileStoreLocatorView() || !$cache.mobileTab.length) {
        return;
    }

    activeMobileTab = tabName === JSConstants.MOBILE_TAB_MAP ? JSConstants.MOBILE_TAB_MAP : JSConstants.MOBILE_TAB_LOCATIONS;

    $cache.mapView
        .removeClass(JSConstants.CLASS_MOBILE_LOCATIONS_ACTIVE)
        .removeClass(JSConstants.CLASS_MOBILE_MAP_ACTIVE)
        .addClass(activeMobileTab === JSConstants.MOBILE_TAB_MAP ? JSConstants.CLASS_MOBILE_MAP_ACTIVE : JSConstants.CLASS_MOBILE_LOCATIONS_ACTIVE);

    $cache.mobileTab.each(function () {
        var $button = $(this);
        var isDisabled = $button.hasClass(JSConstants.CLASS_MOBILE_TAB_DISABLED);
        var isActive = !isDisabled && $button.is(activeMobileTab === JSConstants.MOBILE_TAB_MAP ? selectors.mobileTabMap : selectors.mobileTabLocations);

        $button.toggleClass(JSConstants.CLASS_MOBILE_TAB_ACTIVE, isActive);
        $button.attr('aria-selected', isActive);
        $button.attr('aria-disabled', isDisabled);
        $button.attr('tabindex', isActive ? '0' : '-1');
    });

    if (activeMobileTab === JSConstants.MOBILE_TAB_MAP) {
        setTimeout(function () {
            refresh();

            if (pendingMobileMapStores && pendingMobileMapStores.length) {
                fitMapToStores(pendingMobileMapStores);
            }
        }, 0);
    }
}

function showMobileResults(tabName) {
    setMobileTabsVisibility(true);
    setMobileActiveTab(tabName || JSConstants.MOBILE_TAB_LOCATIONS);
}

function hideMobileResults() {
    setMobileTabsVisibility(false);
    setMobileLocationsTabDisabled(false);
    pendingMobileMapStores = null;
    activeMobileTab = JSConstants.MOBILE_TAB_LOCATIONS;
    $cache.mapView
        .removeClass(JSConstants.CLASS_MOBILE_LOCATIONS_ACTIVE)
        .removeClass(JSConstants.CLASS_MOBILE_MAP_ACTIVE);
}

function handleMobileTabClick() {
    if ($(this).hasClass(JSConstants.CLASS_MOBILE_TAB_DISABLED)) {
        return;
    }

    var isMapTab = $(this).is(selectors.mobileTabMap);
    var tabName = isMapTab ? JSConstants.MOBILE_TAB_MAP : JSConstants.MOBILE_TAB_LOCATIONS;

    setMobileActiveTab(tabName);

    if (isMapTab) {
        setTimeout(function () {
            scrollMobileMapIntoView();
        }, 0);
    }
}

function handleMobileTabKeydown(e) {
    var key = e.key;
    var $tabs = $cache.mobileTab.filter(function () {
        return !$(this).hasClass(JSConstants.CLASS_MOBILE_TAB_DISABLED);
    });

    if (!$tabs.length) {
        return;
    }

    var currentIndex = $tabs.index(this);
    if (currentIndex < 0) {
        currentIndex = 0;
    }
    var nextIndex = currentIndex;

    if (key === 'ArrowRight') {
        nextIndex = (currentIndex + 1) % $tabs.length;
    } else if (key === 'ArrowLeft') {
        nextIndex = (currentIndex - 1 + $tabs.length) % $tabs.length;
    } else if (key === 'Home') {
        nextIndex = 0;
    } else if (key === 'End') {
        nextIndex = $tabs.length - 1;
    } else {
        return;
    }

    e.preventDefault();
    $tabs.eq(nextIndex).focus().click();
}

function renderMobileSelectedStoreCard(storeId) {
    if (!isMobileStoreLocatorView() || !$cache.mobileSelectedStoreBlock.length) {
        return;
    }

    var $selectedStore = $(selectors.nearestStore + '[data-storeid="' + storeId + '"]');

    if (!$selectedStore.length) {
        $cache.mobileSelectedStoreBlock.html('');
        return;
    }

    var $mobileCard = $selectedStore.clone(false, false);
    var $radio = $mobileCard.find('input[type="radio"]');
    var $label = $mobileCard.find('label');
    var mobileInputId = 'mobile-storelocator-' + storeId;

    $mobileCard
        .removeClass(JSConstants.CLASS_NEAREST_STORE_NAME)
        .removeClass(JSConstants.CLASS_STORE_CONTAINER_NAME)
        .addClass(JSConstants.CLASS_STORE_ACTIVE);
    $radio
        .removeClass(JSConstants.CLASS_NEAREST_STORE_RADIO_BTN_NAME)
        .attr('id', mobileInputId)
        .prop('checked', true)
        .prop('disabled', true)
        .removeAttr('name')
        .attr('aria-hidden', 'true')
        .attr('tabindex', '-1');
    $label.attr('for', mobileInputId);

    $cache.mobileSelectedStoreBlock.html($mobileCard);
}

function clearMobileSelectedStoreCard() {
    if ($cache.mobileSelectedStoreBlock.length) {
        $cache.mobileSelectedStoreBlock.html('');
    }
}

function scrollMobileSelectedCardIntoView() {
    if (!isMobileStoreLocatorView() || activeMobileTab !== JSConstants.MOBILE_TAB_MAP) {
        return;
    }

    var $selectedCard = $cache.mobileSelectedStoreBlock.children().first();

    if (!$selectedCard.length) {
        return;
    }

    var cardRect = $selectedCard[0].getBoundingClientRect();
    var bottomMargin = 16;
    var targetScrollTop = window.pageYOffset + cardRect.bottom - window.innerHeight + bottomMargin;

    window.scrollTo({
        top: targetScrollTop,
        behavior: 'smooth'
    });
}

function getHeaderHeight() {
    var header = document.querySelector(JSCommonConstants.CLASS_STICKY_HEADER_MOBILE);
    if (header) {
        return header.offsetHeight;
    }

    var headerHeight = getComputedStyle(document.body).getPropertyValue('--header-height');
    if (headerHeight) {
        return parseInt(headerHeight, 10);
    }

    return 75;
}

function scrollAccordionButtonIntoView($button) {
    if (!$button || !$button.length) {
        return;
    }

    var buttonRect = $button[0].getBoundingClientRect();
    var stickyOffset = layout.isMobile() ? getHeaderHeight() + 8 : 8;
    var targetScrollTop = window.pageYOffset + buttonRect.top - stickyOffset;

    window.scrollTo({
        top: Math.max(targetScrollTop, 0),
        behavior: 'smooth'
    });
}

function scrollMobileMapIntoView() {
    if (!isMobileStoreLocatorView() || activeMobileTab !== JSConstants.MOBILE_TAB_MAP || !$cache.map.length) {
        return;
    }

    var mapRect = $cache.map[0].getBoundingClientRect();
    var stickyOffset = ($cache.mobileTabs.outerHeight() || 0) + getHeaderHeight() + 8;
    var targetScrollTop = window.pageYOffset + mapRect.top - stickyOffset;

    window.scrollTo({
        top: Math.max(targetScrollTop, 0),
        behavior: 'smooth'
    });
}

function showAZView() {
    $cache.azView.show();
    $cache.mapView.hide();
    $cache.storeResultsInfo.hide();

    if (isMobileStoreLocatorView()) {
        hideMobileResults();
        setMobileLocationsTabDisabled(false);
        clearMobileSelectedStoreCard();
    }
}

function showMapView(mobileTabName) {
    $cache.mapView.show();
    $cache.azView.hide();

    if (isMobileStoreLocatorView()) {
        showMobileResults(mobileTabName || activeMobileTab || JSConstants.MOBILE_TAB_LOCATIONS);
    }
}

function loadStores() {
    return $.get(Urls.getStoresJSON, function (data) {
        stores = data;
        showStores(stores);
        showAZViewStores(stores);
        calculateDistanceToStores(stores);
        getLastSearchState();
    });
}

function storeAccordion() {
    $(document).off('click', JSConstants.CLASS_ALPHABET_TITLE)
        .on('click', JSConstants.CLASS_ALPHABET_TITLE, function() {
            toggleAccordionPanel($(this));
        });
}

function toggleAccordionPanel($button) {
    var $container = $button.next(JSConstants.CLASS_ALPHABET_CONTAINER);
    var isExpanded = $button.attr('aria-expanded') === 'true';

    $button.toggleClass(JSConstants.CLASS_ALPHABET_ACTIVE, !isExpanded);
    $container.toggleClass(JSConstants.CLASS_ALPHABET_CLOSE, isExpanded);
    $button.attr('aria-expanded', !isExpanded);

    if (!isExpanded) {
        setTimeout(function() {
            scrollAccordionButtonIntoView($button);
        }, 100);
    }
}

function initEvents() {
    var bindings = [{
        element: selectors.selectStoreBtn,
        event: 'click',
        handler: selectStoreHandler
    }, {
        element: selectors.showNearestStoresLink,
        event: 'click',
        handler: showNearestStoresHandler
    }, {
        element: selectors.fakeLink,
        event: 'click',
        handler: fakeLinkHandler
    }, {
        element: selectors.nearestStoreRadioBtn,
        event: 'click',
        handler: selectStoreHandler
    }, {
        element: selectors.findBtn,
        event: 'click',
        handler: findBtnHandler
    },{
        element: selectors.searchByCurrentLocation,
        event: 'click',
        handler: searchByCurrentLocationHandler
    }, {
        element: selectors.linkToDetailPage,
        event: 'click',
        handler: appendSearchTermHandler
    }, {
        element: selectors.browseAZBtn,
        event: 'click',
        handler: browseAZHandler
    }, {
        element: selectors.mobileTab,
        event: 'click',
        handler: handleMobileTabClick
    }, {
        element: selectors.mobileTab,
        event: 'keydown',
        handler: handleMobileTabKeydown
    }];

    for (var i = 0; i < bindings.length; i++) {
        $(document).on(bindings[i].event, bindings[i].element, bindings[i].handler);
    }

    initAutoCompleteEvents();
    initGlobalWindowEvents();
}

function appendSearchTermHandler() {
    var $this = $(this);
    var searchTerm = $cache.addressField.val();

    if (searchTerm.length > 0) {
        var $href = $this.attr('href');
        let urlParams = new URLSearchParams($href);
        urlParams.append('searchTerm', searchTerm);
        $this.attr('href', decodeURIComponent(urlParams.toString()));
    }
}

function onMarkerClicked(marker) {
    var data = marker.customData;
    var storeId = data.ID;

    if (storeId) {
        selectStoreInMenu(storeId, {
            activateMapTab: isMobileStoreLocatorView(),
            scrollIntoView: !isMobileStoreLocatorView()
        });
        showInfoPopUp(marker);

        if (isMobileStoreLocatorView()) {
            renderMobileSelectedStoreCard(storeId);
            setTimeout(function () {
                scrollMobileSelectedCardIntoView();
            }, 100);
        }
    }
}

function selectStoreHandler() {
    var $self = $(this);
    var storeId = $self.data('storeid') || $self.closest('[data-storeid]').data('storeid');

    selectStore(storeId);
}

function selectStore(storeId) {
    if (!storeId) {
        return;
    }

    var isMobileView = isMobileStoreLocatorView();

    if (isMobileView) {
        pendingMobileMapStores = null;
    }

    selectStoreInMenu(storeId, {
        activateMapTab: isMobileView,
        zoomMap: true,
        scrollIntoView: !isMobileView
    });

    var selectedStoreMarker = findStoreMarker(storeId);

    if (selectedStoreMarker) {
        showInfoPopUp(selectedStoreMarker);
        announceMapCentered(selectedStoreMarker.customData && selectedStoreMarker.customData.name);
    }

    if (isMobileView) {
        renderMobileSelectedStoreCard(storeId);
        setTimeout(function () {
            scrollMobileMapIntoView();
        }, 0);
    }
}

function highlightStoreMarker(marker) {
    if (highlightedMarker && highlightedMarker !== marker) {
        highlightedMarker.setIcon(Object.assign({}, highlightedMarker.getIcon(), {
            fillColor: '#ffffff',
            strokeWeight: 1
        }));
        highlightedMarker.setLabel(Object.assign({}, highlightedMarker.getLabel(), {
            color: '#1f1d1e',
            fontWeight: 'bold'
        }));
    }

    highlightedMarker = marker;
    marker.setIcon(Object.assign({}, marker.getIcon(), {
        fillColor: getMarkerColorByLocale(),
        strokeWeight: 1
    }));
    marker.setLabel(Object.assign({}, marker.getLabel(), {
        color: '#ffffff',
        fontWeight: 'bold'
    }));
}

function showInfoPopUp(marker) {
    highlightStoreMarker(marker);

    if (isMobileStoreLocatorView()) {
        infoWindow.close();
        return;
    }

    var data = marker.customData;
    data.showDistance = showDistance;
    infoWindow.setContent(Handlebars.templates.storeInfoPopupTemplate(data));
    infoWindow.open(map, marker);
}

function onAfterStoreUnselected() {
    $cache.selectedStoreBlock.html('');
    $cache.proceedToPaymentBtn.prop('disabled', true);
    clearMobileSelectedStoreCard();
}

function showStoresMarkers(stores) {
    var indx = 1;
    var filteredStoresIds = _.map(stores, 'ID'),
        visibleMarkers = storeMarkers.filter(function(storeMarker) {
            return ~filteredStoresIds.indexOf(storeMarker.customData.ID);
        });

    _.forEach(storeMarkers, function(storeMarker) {
        !~filteredStoresIds.indexOf(storeMarker.customData.ID) && storeMarker.setVisible(false);
    });

    // Sort visible markers by distance to match store card order
    visibleMarkers.sort(function(a, b) {
        var distanceA = parseFloat(a.customData.distance || 0);
        var distanceB = parseFloat(b.customData.distance || 0);
        return distanceA - distanceB;
    });

    _.forEach(visibleMarkers, function(storeMarker) {
        var isActive = storeMarker === highlightedMarker;
        storeMarker.setVisible(true);
        storeMarker.setLabel({ text: indx.toString(), color: isActive ? '#ffffff' : '#1f1d1e', fontSize: '14px', fontWeight: 'bold' });
        if (storeMarker !== highlightedMarker) {
            storeMarker.setIcon(Object.assign({}, storeMarker.getIcon(), {
                fillColor: '#ffffff'
            }));
        }
        indx++;
    });
}

function fitMapToStores(stores) {
    if (!map || !stores || !stores.length) {
        return;
    }

    var visibleMarkers = storeMarkers.filter(function (storeMarker) {
        return ~_.map(stores, 'ID').indexOf(storeMarker.customData.ID);
    });

    if (!visibleMarkers.length) {
        return;
    }

    if (visibleMarkers.length === 1) {
        map.setCenter(visibleMarkers[0].getPosition());
        map.setZoom(SitePreferences.DEFAULT_MAP_ZOOM);
        return;
    }

    var bounds = new google.maps.LatLngBounds();

    _.forEach(visibleMarkers, function (storeMarker) {
        bounds.extend(storeMarker.getPosition());
    });

    map.fitBounds(bounds, 0);
}

function hideAllStoresMarkers() {
    if (!isHideStoreMarker) {
        _.forEach(storeMarkers, function(storeMarker) {
            storeMarker.setVisible(false);
        });
    }

    isHideStoreMarker = true;
}

function showAllStoresMarkers() {
    if (isHideStoreMarker) {
        _.forEach(storeMarkers, function(storeMarker) {
            storeMarker.setVisible(true);
        });
    }

    isHideStoreMarker = false;
}

function showAZViewStores(stores) {
    var groupDefinitions = [
            { char: 'A – D', range: ['A', 'B', 'C', 'D'], isDefault: true },
            { char: 'E – H', range: ['E', 'F', 'G', 'H'], isDefault: false },
            { char: 'I – M', range: ['I', 'J', 'K', 'L', 'M'], isDefault: false },
            { char: 'N – R', range: ['N', 'O', 'P', 'Q', 'R'], isDefault: false },
            { char: 'S – Z', range: ['S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'], isDefault: false }
        ],
        result = {},
        sortedStores = _.sortBy(stores, 'name');

    _.forEach(groupDefinitions, function(group) {
        result[group.char] = {
            char: group.char,
            stores: [],
            isDefault: group.isDefault || false
        };
    });

    _.forEach(sortedStores, function(store) {
        var firstCharOfName = store.name[0].toUpperCase();
        var targetGroup = _.find(groupDefinitions, function(group) {
            return _.includes(group.range, firstCharOfName);
        });

        if (targetGroup) {
            result[targetGroup.char].stores.push(store);
        }
    });

    $cache.azViewContainer.html(Handlebars.templates.azStoresTemplate({data: result}));

    setTimeout(function() {
        initializeAccordionState();
        storeAccordion();
    }, 100);
}

function initializeAccordionState() {
    $(JSConstants.CLASS_ALPHABET_TITLE).each(function(index) {
        var $button = $(this);
        var $container = $button.next(JSConstants.CLASS_ALPHABET_CONTAINER);
        var isFirstGroup = index === 0;

        $button.attr('aria-expanded', isFirstGroup);

        if (isFirstGroup) {
            $button.addClass(JSConstants.CLASS_ALPHABET_ACTIVE);
            $container.removeClass(JSConstants.CLASS_ALPHABET_CLOSE);
        } else {
            $button.removeClass(JSConstants.CLASS_ALPHABET_ACTIVE);
            $container.addClass(JSConstants.CLASS_ALPHABET_CLOSE);
        }
    });
}

function storesNotFoundHandler() {
    $cache.refinementError.html(Handlebars.templates.showNotFoundErrorMessageBlockTemplate({text: Resources.STORELOCATOR_REFINEMENT_ERROR}));
    $cache.nearestStoresBlock.addClass(JSConstants.CLASS_STORE_EMPTY).html('');
    $cache.storeResultsInfo.hide();
    showAZView();
}

function showNearestStoresHandler(e) {
    e.preventDefault();
    $cache.msgBoxContainer.html('');
    showMapView(JSConstants.MOBILE_TAB_LOCATIONS);
    refresh();

    var nearestStores = getNearestStoresInRadius(stores, $cache.storeRadius.val() || '5');
    showNearestStores(stores, true);
    renderNearestStores(nearestStores);
    selectNearestStore(stores);
    showAllStoresMarkers();
}

function fakeLinkHandler(e) {
    e.preventDefault();
}

function browseAZHandler(e) {
    e.preventDefault();
    showAZView();
    $cache.msgBoxContainer.html('');
    $cache.storeResultsInfo.hide();
    window.scrollTo({ top: 0, behavior: 'smooth' });
}

function markStoreInMenuSelected(storeId, options) {
    options = options || {};

    var $allStores = $(selectors.nearestStore),
        $selectedStore = $(selectors.nearestStore + '[data-storeid="' + storeId + '"]');

    $allStores.find('input[type="radio"]').prop('checked', false);
    $allStores.removeClass(JSConstants.CLASS_STORE_ACTIVE);

    if ($selectedStore && $selectedStore.length) {
        setTimeout(function () {
            $selectedStore.addClass(JSConstants.CLASS_STORE_ACTIVE);
            $selectedStore.find('input[type="radio"]').prop('checked', true);

            if (options.focusCard) {
                $selectedStore.focus();
            }

            if (options.scrollIntoView) {
                $selectedStore[0].scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
            }

            if (options.zoomMap) {
                var selectedStoreMarker = findStoreMarker(storeId);
                if (selectedStoreMarker) {
                    map.setCenter(selectedStoreMarker.getPosition());
                }
                map.setZoom(SitePreferences.DEFAULT_MAP_ZOOM);
            }
        }, 100);
    }
}

function selectStoreInMenu(storeId, options) {
    options = options || {};

    if (isMobileStoreLocatorView()) {
        showMapView(options.activateMapTab ? JSConstants.MOBILE_TAB_MAP : activeMobileTab || JSConstants.MOBILE_TAB_LOCATIONS);
    } else {
        showMapView();
    }

    markStoreInMenuSelected(storeId, {
        focusCard: !isMobileStoreLocatorView(),
        scrollIntoView: options.scrollIntoView,
        zoomMap: options.zoomMap
    });
}

function getFilteredStoresByFeaturesAndRadius(stores) {
    var filteredStoresInRadius = getNearestStoresInRadius(stores, $cache.storeRadius.val() || '5'),
        filteredStores = $cache.addressField.val().length > 0 ? filteredStoresInRadius : stores;

    return filteredStores;

}

function renderNearestStores(nearestStores) {
    $cache.msgBoxContainer.html('');
    $cache.refinementError.html('');

    var radiusValue = $cache.storeRadius.val() || '5';

    updateMapAriaLabel($cache.addressField.val());

    if (nearestStores.length > 0) {
        if (isMobileStoreLocatorView()) {
            setMobileLocationsTabDisabled(false);
            showMapView(JSConstants.MOBILE_TAB_LOCATIONS);
        } else {
            showMapView();
        }

        // Success case
        $cache.nearestStoresBlock.removeClass(JSConstants.CLASS_STORE_EMPTY);
        refresh();

        var message = Resources.STORELOCATOR_RESULTS_COUNT
            .replace('{0}', nearestStores.length)
            .replace('{1}', radiusValue);

        $cache.storeResultsInfo.html(Handlebars.templates.searchResultsMessageTemplate({
            message: message
        }));
        $cache.storeResultsInfo.show();

        if (isMobileStoreLocatorView()) {
            pendingMobileMapStores = nearestStores.slice();

            if (activeMobileTab === JSConstants.MOBILE_TAB_MAP) {
                fitMapToStores(nearestStores);
            }
        } else {
            fitMapToStores(nearestStores);
        }

        selectNearestStore(nearestStores);
    } else {
        if (isMobileStoreLocatorView()) {
            setMobileLocationsTabDisabled(true);
            showMapView(JSConstants.MOBILE_TAB_MAP);
        } else {
            showMapView();
        }

        // No results case
        var searchLocation = $cache.addressField.val();
        var noResultsMessage = Resources.STORELOCATOR_NO_RESULTS_COUNT
            .replace('{0}', radiusValue)
            .replace('{1}', searchLocation);

        $cache.storeResultsInfo.html(Handlebars.templates.searchResultsMessageTemplate({
            message: noResultsMessage
        }));
        $cache.storeResultsInfo.show();
        pendingMobileMapStores = null;

        $cache.nearestStoresBlock.addClass(JSConstants.CLASS_STORE_EMPTY).html('');
        clearSelectedStore();
    }
    // Check if the user entered the exact shop address and trigger the click event
    selectNearestStoreMarker(nearestStores);
}


function getLocationFromAutocomplete() {
    // fetch first option of autocomplete list
    // then extract text from it
    // and pass the result to geocoder
    var $firstOption = $('.pac-container.pac-logo').children().first();

    if ($firstOption && $firstOption.length > 0) {
        var $firstOptionChildren = $firstOption.children();

        var textChunks = [];
        for (var i = 0; i < $firstOptionChildren.length; i++) {
            var child = $firstOptionChildren[i];
            var text = $(child).text();

            if (text) {
                textChunks.push(text);
            }
        }

        return textChunks.join(' ');
    }

    return null;
}

function focusMapOnGeometry(geometry) {
    if (!geometry) {
        return;
    }

    if (geometry.viewport) {
        map.fitBounds(geometry.viewport, 0);
        return;
    }

    if (geometry.location) {
        map.setCenter(geometry.location);
    }
}

function initAutoCompleteEvents() {
    autocomplete.addListener('place_changed', function () {
        var place = autocomplete.getPlace(),
            nearestStores = [];

        if (place && place.geometry) {
            showDistance = true;
            focusMapOnGeometry(place.geometry);
            marker.setPosition(place.geometry.location);

            if (isHideStoreMarker) {
                var filteredStores = getFilteredStoresByFeaturesAndRadius(stores);
                showNearestStores(filteredStores);
                showStoresMarkers(filteredStores);
                showAZViewStores(filteredStores);
                $cache.refinementError.html('');
                showMapView(JSConstants.MOBILE_TAB_LOCATIONS);
                !filteredStores.length && storesNotFoundHandler();
                showAllStoresMarkers();
            } else {
                showNearestStores(stores, false);
            }

            if (storeIdUrlParam) {
                $googleMapSection.trigger('areaSelectedEvent');
            } else {
                nearestStores = getFilteredStoresByFeaturesAndRadius(stores);
                renderNearestStores(nearestStores);
                showStoresMarkers(nearestStores);
            }
        } else {
            var locationString = getLocationFromAutocomplete();

            geocodeAddress(locationString);
        }
    });
}

function geocodeAddress(locationString, updatedAddressField) {
    var address = locationString || $cache.addressField.val();
    var storeRadius = $cache.storeRadius.val();
    var geocodeInfo = { address: address };

    geocoder.geocode(geocodeInfo, function (results, status) {
        if (status === 'OK') {
            var result = results[0],
                nearestStores = [];

            showDistance = true;
            hideAllStoresMarkers();
            focusMapOnGeometry(result.geometry);
            marker.setPosition(result.geometry.location);
            showNearestStores(stores, false);

            if (updatedAddressField) {
                $cache.addressField.val(result.formatted_address);
            }

            if (storeIdUrlParam) {
                $googleMapSection.trigger('areaSelectedEvent');
            } else {
                nearestStores = getNearestStoresInRadius(stores, parseFloat(storeRadius));
                renderNearestStores(nearestStores);
                showStoresMarkers(nearestStores);
            }
        } else {
            $cache.msgBoxContainer.html(Handlebars.templates.showNotFoundErrorMessageBlockTemplate({text: Resources.STORELOCATOR_SEARCH_ERROR}));
            $cache.refinementError.html('');
            $cache.nearestStoresBlock.addClass(JSConstants.CLASS_STORE_EMPTY).html('');
            $cache.storeResultsInfo.hide();

            showAZView();
            map.setCenter(SitePreferences.DEFAULT_MAP_CENTER);
            infoWindow.close();

            clearSelectedStore();
            hideAllStoresMarkers();
            refresh();
        }
    });
}

function initGlobalWindowEvents() {
    $(window).keydown(function(e) {
        // On enter press
        if (e.keyCode === 13) {
            e.preventDefault();
            return false;
        }
    });
}

function initStoreEvents(marker) {
    marker.addListener('click', function() {
        onMarkerClicked(this);
    });
    marker.addListener('mouseover', function() {
        if (this !== highlightedMarker) {
            this.setIcon(Object.assign({}, this.getIcon(), {
                fillColor: getMarkerColorByLocale(),
                strokeWeight: 1
            }));
            this.setLabel(Object.assign({}, this.getLabel(), {
                color: '#ffffff',
                fontWeight: 'bold'
            }));
        }
    });
    marker.addListener('mouseout', function() {
        if (this !== highlightedMarker) {
            this.setIcon(Object.assign({}, this.getIcon(), {
                fillColor: '#ffffff',
                strokeWeight: 1
            }));
            this.setLabel(Object.assign({}, this.getLabel(), {
                color: '#1f1d1e',
                fontWeight: 'bold'
            }));
        }
    });
}

function findBtnHandler() {
    var value = $cache.addressField.val();

    if (value.length > 0) {
        geocodeAddress();
    } else {
        $cache.refinementError.html(Handlebars.templates.showNotFoundErrorMessageBlockTemplate({text: Resources.STORELOCATOR_EMPTY_ERROR}));
    }
}

function searchByCurrentLocationHandler() {
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function(position) {
            var pos = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
            };

            geocodeAddress(pos.lat + ',' + pos.lng, true);
        }, function() {
            $cache.msgBoxContainer.html(Handlebars.templates.showNotFoundErrorMessageBlockTemplate({text: Resources.STORELOCATOR_GEOLOCATION_ERROR}));
        });
    } else {
        $cache.msgBoxContainer.html(Handlebars.templates.showNotFoundErrorMessageBlockTemplate({text: Resources.STORELOCATOR_GEOLOCATION_UNSUPPORTED_ERROR}));
    }
}

function findStoreMarker(storeID) {
    storeID = storeID ? storeID.toString() : '';

    return storeMarkers.find(function(marker) {
        return marker.customData.ID === storeID;
    });
}

function selectNearestStore(stores) {
    var nearestStore = getNearestStore(stores);

    if (nearestStore) {
        if (isMobileStoreLocatorView()) {
            markStoreInMenuSelected(nearestStore.ID, {
                focusCard: false,
                scrollIntoView: false,
                zoomMap: false
            });
        } else {
            selectStoreInMenu(nearestStore.ID, {
                zoomMap: false,
                scrollIntoView: true
            });
        }
    }
}

function selectNearestStoreMarker(stores) {
    if (stores.length <= 0) {
        return;
    }

    var nearestStore = getNearestStore(stores),
        maxDiscrepancy = (SitePreferences.MAX_DISCREPANCY_METERS / 1000) * KILOMETERS_CONVERSATION_LEVEL;

    if (stores && parseFloat(nearestStore.distance) < maxDiscrepancy) {
        var nearestMarker = findStoreMarker(nearestStore.ID);

        if (nearestMarker) {
            if (isMobileStoreLocatorView()) {
                markStoreInMenuSelected(nearestStore.ID, {
                    focusCard: false,
                    scrollIntoView: false,
                    zoomMap: false
                });
            } else {
                onMarkerClicked(nearestMarker);
            }
        }
    }
}

function getNearestStore(stores) {
    var nearestStore = _.minBy(stores, function(store) {
        return parseFloat(store.distance);
    });

    return nearestStore;
}

function clearSelectedStore() {
    onAfterStoreUnselected();
}

function showStores(stores) {
    var bounds = new google.maps.LatLngBounds();
    var hasStoreMarkers = false;

    for (var key in stores) {
        if (!Object.prototype.hasOwnProperty.call(stores, key)) {
            continue;
        }
        var store = stores[key];
        if (!isEmpty(store.latitude) && !isEmpty(store.longitude)) {
            const svgMarker = {
                path: "M12 2C7.5 2 4 5.8 4 10.6C4 15.8 12 22 12 22S20 15.8 20 10.6C20 5.8 16.5 2 12 2Z",
                fillColor: "#ffffff",
                fillOpacity: 1,
                strokeColor: getMarkerColorByLocale(),
                strokeWeight: 1,
                rotation: 0,
                scale: 1.6,
                size: new google.maps.Size(72, 80),
                anchor: new google.maps.Point(12, 22),
                labelOrigin: new google.maps.Point(12, 10)
            };
            var marker = new google.maps.Marker({
                    position: {
                        lat: store.latitude,
                        lng: store.longitude
                    },
                    map: map,
                    title: store.name,
                    icon: svgMarker,
                    customData: store,
                    label: { text: (parseInt(key, 10) + 1).toString(), color: '#1f1d1e', fontSize: '14px', fontWeight: 'bold' }
                });
            storeMarkers.push(marker);
            initStoreEvents(marker);
            bounds.extend(marker.getPosition());
            hasStoreMarkers = true;
        }
    }

    if (hasStoreMarkers) {
        map.fitBounds(bounds, 0);

        if (isMobileStoreLocatorView()) {
            google.maps.event.addListenerOnce(map, 'idle', function () {
                if (map.getZoom() < SitePreferences.DEFAULT_MAP_ZOOM) {
                    map.setZoom(SitePreferences.DEFAULT_MAP_ZOOM);
                }
            });
        }
    }
}

function isEmpty(value) {
    return (value === null || (typeof value === 'undefined') || value.length === 0);
}

function compareDistance(a, b) {
    if (parseFloat(a.distance) < parseFloat(b.distance)) {
        return -1;
    }
    if (parseFloat(a.distance) > parseFloat(b.distance)) {
        return 1;
    }
    return 0;
}

function calculateDistanceToStores(stores) {
    for (var key in stores) {
        var store = stores[key],
            distance = google.maps.geometry.spherical.computeDistanceBetween(marker.getPosition(), new google.maps.LatLng({lat: store.latitude, lng: store.longitude})) * KILOMETERS_CONVERSATION_LEVEL;

        store.distance = parseFloat(distance / 1000).toFixed(3);
        store.distanceText = parseFloat(distance / 1000).toFixed(1);
    }
    return stores;
}

function showNearestStores(stores, trimStoresByQuantity) {
    var nearestStores = getNearestStoresInRadius(stores, $cache.storeRadius.val() || '5'),
        sortedStores = stores.slice().sort(compareDistance),
        sortedNearestStores = nearestStores.sort(compareDistance),
        trimedNearestStoresByQuantity = trimStoresByQuantity ? sortedStores.slice(0, SitePreferences.MAX_NEAREST_STORES_QUANTITY) : sortedNearestStores;

    var storesWithOrder = trimedNearestStoresByQuantity.map(function(store, index) {
        var storeWithOrder = Object.assign({}, store);
        storeWithOrder.orderNumber = index + 1;
        storeWithOrder.distanceFormatted = Resources.GOOGLEMAPS_DISTANCE_MSGF.replace('{0}', store.distanceText);
        storeWithOrder.directionsAriaLabel = Resources.STORELOCATOR_GET_DIRECTIONS_ARIA.replace('{0}', store.name);
        storeWithOrder.viewDetailsAriaLabel = Resources.STORELOCATOR_VIEW_DETAILS_ARIA.replace('{0}', store.name);
        return storeWithOrder;
    });

    $cache.nearestStoresBlock.html(Handlebars.templates.nearestStoresTemplate({data: storesWithOrder}));
    $cache.nearestStoresBlock.removeClass(JSConstants.CLASS_STORE_EMPTY);
}

function getNearestStoresInRadius(stores, radius) {
    var nearestStores = calculateDistanceToStores(stores).filter(function(store) {
        return parseFloat(store.distance) <= parseFloat(radius);
    });

    return nearestStores;
}

function getRegionByLocale(locale) {
    var region = '';
    try {
        region = JSON.parse(SitePreferences.GOOGLE_MAPS_REGION);
    } catch (e) {
        console.error('GoogleMaps: ' + e.message);
    }
    region = region[locale] || 'uk';
    return region;
}

function getMarkerColorByLocale() {
    var region = getRegionByLocale(SitePreferences.LOCALE);
    return (region === 'uk' || region === 'ie') ? '#ee3780' : '#f1912b';
}

function refresh() {
    if (!map) {
        return false;
    }

    var zoom = map.getZoom(),
        center = map.getCenter();

    google.maps.event.trigger(map, 'resize');

    map.setZoom(zoom);
    map.setCenter(center);
}

function disableScrollRestoration() {
    if ('scrollRestoration' in history) {
        history.scrollRestoration = 'manual';
    }
}

function init() {
    handlebarsHelper.compileTemplates();
    disableScrollRestoration();

    var data = {
        key: SitePreferences.GOOGLE_API_KEY,
        libraries: 'geometry,places',
        region: getRegionByLocale(SitePreferences.LOCALE),
        language: SitePreferences.LOCALE
    };

    if (!isInited) {
        $.ajax({
            url: Urls.googlemapsAPIUrl,
            data: data,
            dataType: 'jsonp',
            jsonpCallback: 'initStorelocatorMap'
        });
    } else {
        refresh();
    }

    isInited = true;
}

module.exports.init = init;
module.exports.refresh = refresh;
